import { Attributes, Misc, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';

export default class AccrualAdjustment extends TemporalEntity {
    static typeName = "AccrualAdjustment";

    constructor() {
        super();
        this.makeObservable();
    }

    public accrualAdjustmentId: number = 0;

    public investmentId: number = 0;

    @Rules.Required()
    @Attributes.Float()
    public amount: number = 0;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public adjustmentDate: Date | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New accrual adjustment";
        } else {
            return "Accrual Adjustment";
        }
    }
}